import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { Box, Stack, Typography } from '@mui/material'

export const ErrorScreen = () => {
  return (
    <Box
      alignItems="center"
      display="flex"
      height="100vh"
      justifyContent="center"
      width="100vw"
    >
      <Stack alignItems="center" mb={25} spacing={5}>
        <ErrorOutlineIcon sx={{ fontSize: '60px' }} />
        <Typography fontSize="40px">Whoops, something went wrong</Typography>
        <Typography color="secondary.dark" fontSize="30px">
          Please try again later
        </Typography>
      </Stack>
    </Box>
  )
}
